import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import withModal from 'components/modals/withModal';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { destroyAccountContacts } from 'redux/actions/contactActions';
import ConfirmationModal from '../../../modals/ConfirmationModal';


class DeleteModal extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    contact: PropTypes.shape({
      id: PropTypes.string,
      contact_id: PropTypes.string,
      email: PropTypes.string,
    }).isRequired,
    account: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    getContacts: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    destroyAccountContacts: PropTypes.func.isRequired,
    showNotification: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isOpen: false,
  };

  handleSubmit = async () => {
    const {
      contact,
      getContacts,
      toggle,
      account,
      showNotification,
    } = this.props;
    await this.props.destroyAccountContacts(
      account.id,
      {
        sequence_ids: contact.current_campaign_sequences.map(el => el.sequence),
        contact_ids: [contact.contact_id],
      },
    );

    toggle();
    await getContacts();
    showNotification(`${contact.email} was deleted`, 'success');
  }

  render() {
    const { toggle, isOpen, contact } = this.props;
    return (
      <ConfirmationModal
        open={isOpen}
        onBackdropClick={toggle}
        title="Confirm"
        confirmLabel="Yes"
        onConfirmClick={this.handleSubmit}
        onCancelClick={toggle}
      >
        <React.Fragment>
          <span className="volt-modal--stressed">{contact.email}</span> will be&nbsp;
          <span className="volt-modal--red">DELETED</span> from all sequences associated to this account,&nbsp;
            are you sure?
        </React.Fragment>
      </ConfirmationModal>
    );
  }
}

export default compose(connect(
  state => ({
    account: state.account,
  }),
  {
    destroyAccountContacts,
  },
))(withModal(DeleteModal));
